require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./estos-son-los-favoritos-de-bam-bam-zamorano-para-ganar-la-champions-league.json") })
        }
      }, "path---estos-son-los-favoritos-de-bam-bam-zamorano-para-ganar-la-champions-league");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---estos-son-los-favoritos-de-bam-bam-zamorano-para-ganar-la-champions-league!./.cache/json/estos-son-los-favoritos-de-bam-bam-zamorano-para-ganar-la-champions-league.json
// module id = 449
// module chunks = 231608221292675